import React, { ChangeEvent } from 'react';
import Icon, { COLORS } from '../icon';
import classNames from 'classnames';
import './icon-toggle.scss';

interface IconToggleProps {
	leftIconName: string;
	leftValue: string | number;
	middleIconName?: string;
	middleValue?: string | number;
	rightIconName: string;
	rightValue: string | number;
	onToggle: (event: ChangeEvent<HTMLInputElement>) => void;
	selected: string | number;
	name?: string;
}

export default function IconToggle({
	leftIconName,
	leftValue,
	middleIconName,
	middleValue,
	rightIconName,
	rightValue,
	onToggle,
	selected,
	name = 'toggle',
}: IconToggleProps): JSX.Element {
	const leftSelected = leftValue === selected;
	const middleSelected = middleValue === selected;
	const rightSelected = rightValue === selected;

	const isMiddleIcon = !!middleIconName && !!middleValue;
	return (
		<div
			className={classNames('icon-toggle', {
				'three-wide': isMiddleIcon,
			})}
		>
			<input
				name={name}
				id={`left-${name}`}
				type="radio"
				checked={leftSelected}
				value={leftValue}
				onChange={onToggle}
			/>
			<label htmlFor={`left-${name}`}>
				<Icon
					name={leftIconName}
					size={16}
					color={leftSelected ? COLORS.WHITE : COLORS.GRAY}
				/>
			</label>
			{isMiddleIcon && (
				<>
					<input
						name={name}
						id={`middle-${name}`}
						type="radio"
						checked={middleSelected}
						value={middleValue}
						onChange={onToggle}
					/>
					<label htmlFor={`middle-${name}`}>
						<Icon
							name={middleIconName!}
							size={16}
							color={middleSelected ? COLORS.WHITE : COLORS.GRAY}
						/>
					</label>
				</>
			)}
			<input
				name={name}
				id={`right-${name}`}
				type="radio"
				checked={rightSelected}
				value={rightValue}
				onChange={onToggle}
			/>
			<label htmlFor={`right-${name}`}>
				<Icon
					name={rightIconName}
					size={16}
					color={rightSelected ? COLORS.WHITE : COLORS.GRAY}
				/>
			</label>
		</div>
	);
}
